import React, { Fragment } from 'react'
import {
    forFeature,
    i18n,
} from '../../validator'
import Configurator from '../../configurator'
import classnames from 'classnames'
import MobileStoreLink from '../app-stores/mobile-store-link'
import {
    DEVICE_ANDROID,
    DEVICE_IOS,
    RESPONSIVE_WIDTH,
} from '../../consts'
import CollapsibleSection from '../../admin/components/events/form/collapsible-section'
import LanguageSwitcher from '../../front/components/shared/sn-language-switcher'
import { NavLink } from '../../front/components/shared/sn-link'

const facebookIcon = '/images/socials/Facebook.svg'
const instagramIcon = '/images/socials/Instagram.svg'
const youtubeIcon = '/images/socials/Youtube.svg'
const tiktokIcon = '/images/socials/Tiktok.svg'

@forFeature('SPORTNECT_FOOTER')
@i18n()
export default class Footer extends Configurator {
    state = {
        hideLinks: this.config.windowWidth < RESPONSIVE_WIDTH,
    }

    /**
     * Render links column
     *
     * @return {XML}
     */
    renderLinksCol = () => {
        const footerLinks = this.config.REACT_APP_FOOTER_LINKS_LEFT
        const footerLinksParsed = footerLinks || {}
        const { hideLinks } = this.state
        const { t } = this.props

        return (
            <CollapsibleSection
                defaultCollapsed={hideLinks}
                title={t('aboutProject')}
                bigArrow
            >
                <ul>
                    {footerLinks && Object.keys(footerLinksParsed).map((link, index) =>(
                        <li key={index}>
                            <NavLink
                                to={`/${link}`}
                                className="Footer__link"
                                onClick={this.scrollTop}
                            >
                                {t(footerLinksParsed[link])}
                            </NavLink>
                        </li>
                    ))}
                    <li className="pr-5">
                        <NavLink
                            to="/terms-and-conditions"
                            target="_blank"
                            className="Footer__link"
                        >
                            {t('termsAndConditions')}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/news/cenik"
                            onClick={this.scrollTop}
                        >
                            {t('footerLinks.priceList')}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/faq"
                            onClick={this.scrollTop}
                        >
                            {t('faq')}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/contact"
                            onClick={this.scrollTop}
                        >
                            {t('contactOnSportnect')}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/news"
                            onClick={this.scrollTop}
                        >
                            {t('blog')}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/news/oceneni"
                            onClick={this.scrollTop}
                        >
                            {t('footerLinks.awards')}
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/changelog"
                            onClick={this.scrollTop}
                        >
                            {t('changelog')}
                        </NavLink>
                    </li>
                </ul>
            </CollapsibleSection>
        )
    }

    /**
     * Render "use us" column
     *
     * @return {XML|null}
     */
    renderUseUsCol = () => {
        const footerLinks = this.config.REACT_APP_FOOTER_LINKS_RIGHT
        const footerLinksParsed = footerLinks || {}
        const { hideLinks } = this.state
        const { t } = this.props

        return (
            <CollapsibleSection
                defaultCollapsed={hideLinks}
                title={t('whoUseUs')}
                bigArrow
            >
                <ul>
                    {footerLinks && Object.keys(footerLinksParsed).map((link, index) =>(
                        <li key={index}>
                            <NavLink
                                to={`/${link}`}
                                className="Footer__link"
                                onClick={this.scrollTop}
                            >
                                {t(footerLinksParsed[link])}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </CollapsibleSection>
        )
    }

    /**
     * Render partners column
     *
     * @return {XML}
     */
    renderPartnersCol = () => {
        const { hideLinks } = this.state
        const { t } = this.props

        return (
            <Fragment>
                <CollapsibleSection
                    defaultCollapsed={hideLinks}
                    title={t('projectPartners')}
                    bigArrow
                >
                    <div className="d-flex">
                        <ul>
                            <li>
                                <NavLink
                                    to="/news/partneri"
                                    onClick={this.scrollTop}
                                >
                                    {t('footerLinks.partners')}
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/news/jak-se-stat-partnerem"
                                    onClick={this.scrollTop}
                                >
                                    {t('footerLinks.becomePartner')}
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/news/ambasadori"
                                    onClick={this.scrollTop}
                                >
                                    {t('footerLinks.projectAmbasadors')}
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </CollapsibleSection>
            </Fragment>
        )
    }

    /**
     * Render partners column
     *
     * @return {XML}
     */
    renderSocialCol = () => {
        const FBLink = this.config.REACT_APP_FOOTER_FACEBOOK_LINK
        const InstagramLink = this.config.REACT_APP_FOOTER_INSTAGRAM_LINK
        const TikTokLink = this.config.REACT_APP_FOOTER_TIKTOK_LINK
        const YoutubeLink = this.config.REACT_APP_FOOTER_YOUTUBE_LINK

        const { t } = this.props

        return(
            <Fragment>
                <div className="Footer__column-title">
                    {t('footerTitle.socials')}
                </div>
                <div className="d-flex">
                    <a href={FBLink} target="_blank" rel="noopener noreferrer" className="Footer__social-logo">
                        <img src={facebookIcon} alt=""/>
                    </a>
                    <a href={InstagramLink} target="_blank" rel="noopener noreferrer" className="Footer__social-logo">
                        <img src={instagramIcon} alt=""/>
                    </a>
                    <a href={YoutubeLink} target="_blank" rel="noopener noreferrer" className="Footer__social-logo">
                        <img src={youtubeIcon} alt=""/>
                    </a>
                    <a href={TikTokLink} target="_blank" rel="noopener noreferrer" className="Footer__social-logo">
                        <img src={tiktokIcon} alt=""/>
                    </a>
                </div>
            </Fragment>
        )
    }

    /**
     * Render (or not) mobile apps col
     *
     * @return {*}
     */
    renderMobileAppsCol = () => {
        if (!this.config.REACT_APP_FOOTER_MOBILE_TEXT) {
            return null
        }

        const { t } = this.props

        return (
            <Fragment>
                <div className="Footer__column-title mt-5">
                    {t('mobileApps')}
                </div>
                <div className="Footer__mobile-apps">
                    <div className="Footer__mobile-apps-links">
                        <MobileStoreLink forDevice={DEVICE_IOS} linkClassName="Footer__mobile-apps-link"/>
                        <MobileStoreLink forDevice={DEVICE_ANDROID} linkClassName="Footer__mobile-apps-link"/>
                    </div>
                </div>
            </Fragment>
        )
    }

    /**
     * Render lists column
     *
     * @return {*}
     */
    renderListsCol = () => {
        const { hideLinks } = this.state
        const { t } = this.props

        return (
            <div className="mb-0 mt-4">
                <CollapsibleSection
                    defaultCollapsed={hideLinks}
                    title={t('lists')}
                    bigArrow
                >
                    <ul>
                        <li><a href="/seznam-udalosti">{t('listOfEvents')}</a></li>
                        <li><a href="/seznam-klubu">{t('groupsList')}</a></li>
                        <li><a href="/seznam-sportovist">{t('sportVenuesList.list')}</a></li>
                        <li><a href="/seznam-novinek">{t('blog')}</a></li>
                        <li><a href="/seznam-funkci">{t('footerLinks.features')}</a></li>
                    </ul>
                </CollapsibleSection>
            </div>
        )
    }

    /**
     * Render
     *
     * @return {JSX.Element}
     */
    render = () => {
        const { t } = this.props

        return (
            <footer className={classnames({
                'Footer': true,
                [this.props.footerClass]: !!this.props.footerClass,
            })}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12 Footer__column">
                            {this.renderLinksCol()}
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 Footer__column">
                            {this.renderUseUsCol()}
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 Footer__column">
                            {this.renderPartnersCol()}
                            {this.renderListsCol()}
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 Footer__column">
                            {this.renderSocialCol()}
                            {this.renderMobileAppsCol()}
                            <div className="Footer__column-title">
                                {t('footerTitle.language')}
                            </div>
                            <LanguageSwitcher/>
                        </div>
                    </div>
                </div>
                <div className="Footer__sub container flex-wrap">
                    <div
                        className="Footer__logo"
                        dangerouslySetInnerHTML={{ __html: this.config.REACT_APP_FOOTER_SUB_LOGO }}
                    />
                    <small className="pt-3 text-color-gray-dark-2">
                        {t('footer.copyrightText')}&nbsp;&nbsp;&nbsp;&nbsp;
                        {this.config.REACT_APP_VERSION}
                    </small>
                </div>
            </footer>
        )
    }
}
